// src/components/ThemeToggle.jsx
import { useTheme } from '../context/ThemeContext';

function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();

    return null; // Hidden as requested

    // return (
    //     <button
    //         className="theme-toggle-btn"
    //         onClick={toggleTheme}
    //         title={`Switch to ${theme === 'classic' ? 'Enhanced' : 'Classic'} Mode`}
    //     >
    //         <i className={theme === 'classic' ? 'fas fa-magic' : 'fas fa-undo'}></i>
    //         <span>{theme === 'classic' ? 'Enhanced' : 'Classic'}</span>
    //     </button>
    // );
}

export default ThemeToggle;
